import request from "@/utils/request";

export function getProvince() {
  return request({
    url: "/client/common/area/getProvince",
    method: "get",
  });
}

export function getCity(provinceId) {
  return request({
    url: `/client/common/area/getCity?provinceId=${provinceId}`,
    method: "get",
  });
}

export function getDistrict(cityId) {
  return request({
    url: `/client/common/area/getDistrict?cityId=${cityId}`,
    method: "get",
  });
}

export function getSiteConfig() {
  return request({
    url: `/client/siteConfig/get`,
    method: "get",
  });
}
